import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useTokenStore } from '@/stores/token'
import { useRequestsStore } from '@/stores/requests'
import { useTranslaterStore } from '@/stores/translater'

export const useUsersStore = defineStore('users', () => {

    const configStore   = useConfigStore()
    const tokenStore    = useTokenStore()
    const requestStore  = useRequestsStore()
    const getTranslate  = useTranslaterStore().getTranslate

    const users = ref({})
    const usersProcess = ref(false)
    const usersMsg = ref({})

    const user = ref({})
    const userProcess = ref(false)
    const userMsg = ref({})

    const userCreateProcess = ref(false)
    const userCreateMsg = ref({})

    const userUpdateProcess = ref(false)
    const userUpdateMsg = ref({})

    const userDeleteProcess = ref(false)
    const userDeleteMsg = ref({})

    const userTypes = ref([
        'USER_TYPE_USER',
        'USER_TYPE_EXPERT',
        'USER_TYPE_SUPER'
    ])

    const userAttributes = ref([
        'LOGS_CAR', 
        'EDIT_PRIVATE_CAR', 
        'GEODATA', 
        'REMOTE_CONTROL', 
        'DIAGNOSTIC', 
        'PARAM', 
        'FIRMWARE', 
        'MULTI_FIRMWARE',
        'COMMAND', 
        'GROUP_ADMIN',
        'SUPER_ADMIN', 
        'SEER_CAR', 
        'CREATOR_CAR', 
        'CERTIFICATE_ADMIN'
    ])

    const usersGroups = ref({ array: [] })
    const usersGroupsProcess = ref(false)
    const usersGroupsMsg = ref({})

    /**
     * Создаёт нового пользователя
     * 
     * @param {Object} payload - объект с полями формы создания нового пользователя
     */
    async function createUser(payload) {

        userCreateProcess.value = true
        const token = tokenStore.access

        if(token) {

            const request = await requestStore.fetchRequest({
                address: `${configStore.httpServer}/users`, 
                method: 'POST', 
                token,
                data: payload
            })

            if(!request.error) {
                userCreateMsg.value = { success: true, text: 'USER_CREATE_SUCCESS' }
            } else {
                userCreateMsg.value = { success: false }
                userCreateMsg.value.text = request.error
            }

        } else {
            userCreateMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        userCreateProcess.value = false
    }

    /**
     * Получает пользователей
     * 
     * @param {String} payload - параметры запроса [см.swagger]
     */
    async function readUsers(payload) {

        usersProcess.value = true
        const token = tokenStore.access

        if(token) {

            let params = ''

            if(payload) {

                for( let param in payload) {

                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }

            const request = await requestStore.fetchRequest({
                address: `${configStore.httpServer}/users${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {

                users.value = request

                // Получаем группу пользователей по UUID групп
                if(users.value.array.length) {

                    let usersUuids = []
                    users.value.array.map(user => user.ugroup ? usersUuids.push(user.ugroup) : false)

                    if(usersUuids.length) {

                        let params = ''
                        usersUuids.map(uuid => params.length ? params += '&uuid_array=' + uuid : params = '?uuid_array=' + uuid)

                        const request = await requestStore.fetchRequest({
                            address: `${configStore.httpServer}/ugroups${params}`, 
                            method: 'GET', 
                            token
                        })

                        if(!request.error && request.array.length) {
                            request.array.map(group => {
                                users.value.array.map(user => { 
                                    if(user.ugroup == group.uuid) {
                                        user.group = group
                                    }
                                })
                            })
                        }
                    }
                }

                usersMsg.value = { success: true }

            } else {
                users.value = { array: [] }
                usersMsg.value = { success: false }
                usersMsg.value.text = request.error
            }

        } else {
            usersMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        usersProcess.value = false
        return users.value
    }

    /**
     * Получает пользователя по UUID
     * 
     * @param {String} payload - UUID пользователя в системе
     */
    async function readUser(payload) {

        userProcess.value = true
        const token = tokenStore.access

        if(token) {

            const request = await requestStore.fetchRequest({
                address: `${configStore.httpServer}/users/${payload}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                user.value = request
                userMsg.value = { success: true }

            } else {
                user.value = {}
                userMsg.value = { success: false, text: request.error }
            }

        } else {
            userMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        userProcess.value = false
        return user.value
    }

    /**
     * Обновляет профиль пользователя
     * 
     * @param {Object} payload - объект с полями формы профиля пользователя
     */
    async function updateUser(payload) {

        const token = tokenStore.access

        if(token) {

            userUpdateProcess.value = true

            const request = await requestStore.fetchRequest({
                address: `${configStore.httpServer}/users`, 
                method: 'PUT', 
                token,
                data: payload
            })

            if(!request.error) {

                user.value = request
                userUpdateMsg.value = { success: true, text: 'USER_UPDATE_SUCCESS' }

            } else {

                userUpdateMsg.value = { success: false }
                userUpdateMsg.value.text = request.error
            }
        
            userUpdateProcess.value = false
            
        } else {

            userUpdateMsg.value = { success: false, text: 'EUnauthRequest' }
        }
    }

    /**
     * Удаление пользователя
     * 
     * @param {Object} payload - ID пользователя
     */
    async function deleteUser(payload) {

        const token = tokenStore.access

        if(token) {

            userDeleteProcess.value = true

            const request = await requestStore.fetchRequest({
                address: `${configStore.httpServer}/users/${payload}`, 
                method: 'DELETE', 
                token
            })

            if(!request.error) {

                userDeleteMsg.value = { success: true, text: 'USERS_DELETE_SUCCESS', data: { uuid: payload } }

            } else {

                userDeleteMsg.value = { success: false }
                userDeleteMsg.value.text = getTranslate[request.error] || request.error
            }

            userDeleteProcess.value = false

        } else {

            userDeleteMsg.value = { success: false, text: getTranslate.EUnauthRequest }
        }
    }

    const setCreateUserMsg  = data => userCreateMsg.value = data
    const setUsersMsg       = data => usersMsg.value      = data
    const setUser           = data => user.value          = data
    const setUserMsg        = data => userMsg.value       = data
    const setUpdateUserMsg  = data => userUpdateMsg.value = data
    const setDeleteUserMsg  = data => userDeleteMsg.value = data

    return {

        users,
        usersProcess,
        usersMsg,

        user,
        userProcess,
        userMsg,

        userCreateProcess,
        userCreateMsg,

        userUpdateProcess,
        userUpdateMsg,

        userDeleteProcess,
        userDeleteMsg,

        userTypes,

        userAttributes,

        usersGroups,
        usersGroupsProcess,
        usersGroupsMsg,

        createUser,
        readUsers, 
        readUser, 
        updateUser, 
        deleteUser, 

        setCreateUserMsg,
        setUsersMsg,
        setUser,
        setUserMsg,
        setUpdateUserMsg,
        setDeleteUserMsg
    }
})